import React from 'react';
import { NewPage } from './NewPage/NewPage';

import './WorkArea.scss';

export const WorkArea = () => (
        <div className='field-work-area'>
            <NewPage mode={'editing'} />
        </div>
);